var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme, { mediaQueries } from '../../../Theme';
import { Button, Field, FieldType } from '../../../elements';
import Packet from '../Model';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { rules, Validation } from '../../../helpers/Validation';
import { Iconos } from '../../../elements/IconosApp';
import Calculator from '../../../components/Calculator';
import { T as Traduce, t, T } from '../../../helpers/i18n';
import { ButtonsBar } from '../../../Styles';
import History, { toParentPath } from '../../../helpers/History';
import Text from '../../../elements/Text';
import { mapValues, objectValues } from '../../../helpers/Utils';
import { store as mainStore } from '../../../App';
import SettingService, { getIndexForMapeo } from './SettingService';
var PacketsF = /** @class */ (function (_super) {
    __extends(PacketsF, _super);
    /* ************************************************************************************************************ */
    function PacketsF(props) {
        var _this = _super.call(this, props) || this;
        _this.priceFields = _this.props.passengerCategories.map(function (item) {
            // console.log('item', item)
            var prices = _this.props.packet ? _this.props.packet.prices : [];
            var esquema = {};
            prices.forEach(function (priceItem) {
                esquema[priceItem.passengerCategory_id] = priceItem.price;
            });
            // console.log('esquema', esquema)
            return {
                name: item.name,
                type: FieldType.Text,
                rules: rules().number(),
                size: 2,
                id: item.id,
                value: esquema[item.id]
            };
        });
        _this.schema = {
            name: rules().string().required(),
            code: rules().string().required(),
            tax_id: rules().number().integer().required(),
            operationLine_id: rules().number().integer().required(),
            printPrice: rules().boolean(),
            headboard_id: rules().number().integer().required(),
            description: rules().string(),
            emails: rules().string(),
            icon: rules().string(),
            stretchValues: _this.props.packet ? undefined : rules().required(),
            collaboratorStretchValues: _this.props.packet ? undefined : rules(),
            stretchesSelected: rules().array(),
            aditional: rules().string().max(254),
        };
        _this.packetSchema = _this.priceFields.reduce(function (previous, current) {
            previous[current.name] = current.rules;
            return previous;
        }, {});
        // operationLines
        _this.operations = _this.props.operationLines ? _this.props.operationLines : [];
        _this.operationsMapeados = _this.operations.map(function (item) {
            // console.log('item', item)
            return {
                value: String(item.id),
                name: item.name
            };
        });
        _this.operationsOptions = !_this.props.packet ? __spreadArray([{ value: '0', name: '' }], _this.operationsMapeados, true) : _this.operationsMapeados;
        // stretches seleccionados
        _this.stretches = _this.props.stretches ? _this.props.stretches : [];
        _this.stretchesMapeados = _this.stretches.map(function (item) {
            // console.log('item', item)
            var hours = item.horasIda.reduce(function (previousValue, currentValue) {
                previousValue += "".concat(currentValue.hours, ":").concat(currentValue.minutes, " ");
                return previousValue;
            }, '');
            return {
                isCollaboratorStretch: false,
                value: String(item.id),
                name: "".concat(item.name),
                selected: _this.props.packet ? _this.props.packet.stretches.findIndex(function (element) { return element.id === item.id; }) !== -1 : false
            };
        });
        _this.stretchesOptions = __spreadArray([], _this.stretchesMapeados, true);
        _this.collaboratorStretches = _this.props.collaboratorStretches || [];
        _this.collaboratorStretchesMapeados = _this.collaboratorStretches.map(function (collaboratorStretch) {
            var value = {
                stretch_id: collaboratorStretch.id,
                operator_id: collaboratorStretch.operator_id
            };
            var selected = _this.props.packet && _this.props.packet.collaboratorStretches ? _this.props.packet.collaboratorStretches.find(function (element) {
                return element.id === collaboratorStretch.id && element.operator_id === collaboratorStretch.operator_id;
            }) : false;
            return {
                isCollaboratorStretch: true,
                value: JSON.stringify(value),
                name: "".concat(collaboratorStretch.name),
                selected: selected
            };
        });
        _this.collaboratorStretchesOptions = __spreadArray([], _this.collaboratorStretchesMapeados, true);
        // headboards
        _this.headboards = _this.props.headboards || [];
        _this.headboardsMapeados = _this.headboards.map(function (item) {
            return {
                value: String(item.id),
                name: item.name,
                selected: _this.props.packet && _this.props.headboards && _this.props.headboards.length > 0 ?
                    _this.props.headboards.find(function (headboard) { return headboard.id === item.id; }) : false
            };
        });
        _this.headboardsOptions = !_this.props.packet ? __spreadArray([{ value: '0', name: '' }], _this.headboardsMapeados, true) : _this.headboardsMapeados;
        // articles
        _this.articles = _this.props.articles || [];
        _this.articlesMapeados = _this.articles.map(function (item) {
            return {
                value: String(item.id),
                name: item.name,
                // selected: this.props.packet? this.props.packet.articles.findIndex(element => element.article.id === item.id) !== -1: false
            };
        });
        _this.articlesOptions = __spreadArray([{ value: '0', name: '' }], _this.articlesMapeados, true);
        // taxes
        _this.taxes = _this.props.taxes ? _this.props.taxes : [];
        _this.taxesMapeados = _this.taxes.map(function (item) {
            // console.log('item', item)
            return {
                value: String(item.id),
                name: item.name
            };
        });
        _this.taxesOptions = !_this.props.packet ? __spreadArray([{ value: '0', name: '' }], _this.taxesMapeados, true) : _this.taxesMapeados;
        _this.mapNameId = {};
        /* ************************************************************************************************************ */
        _this.mapHoursSelected = function (hoursSelected, schedules) {
            var result = {};
            if (!schedules) {
                return result;
            }
            var _loop_1 = function (stretch_id) {
                if (hoursSelected.hasOwnProperty(stretch_id)) {
                    var tempHoras_1 = [];
                    var horas = hoursSelected[stretch_id];
                    horas.forEach(function (horaId) {
                        var hora = schedules.find(function (schedule) { return schedule.id === Number(horaId.id); });
                        if (!hora) {
                            // hay una hora que ya no está en el sistema, de momento mostramos error
                            return _this.props.store.UI.newError('Hay un error con la hora, código error 800');
                        }
                        tempHoras_1.push(hora);
                    });
                    result[stretch_id] = tempHoras_1;
                }
            };
            for (var stretch_id in hoursSelected) {
                _loop_1(stretch_id);
            }
            // console.log('mapHoursSelected - result: ', result)
            return result;
        };
        _this.mapCollaboratorHoursSelected = function (collaboratorHoursSelected, collaboratorStretches) {
            // console.log('collaboratorHoursSelected: ', collaboratorHoursSelected)
            // console.log('collaboratorStretches: ', collaboratorStretches)
            var result = {};
            var entries = collaboratorHoursSelected ? Object.entries(collaboratorHoursSelected) : [];
            var _loop_2 = function (key, entrieValue) {
                // console.log('key: ', key)
                // console.log('value: ', entrieValue)
                // desmapeo stretch_operatorID
                var resultDesMaped = String(key).split('_');
                // console.log('resultDesMaped: ', resultDesMaped)
                var stretch_id = Number(resultDesMaped[0]);
                var operator_id = Number(resultDesMaped[1]);
                // console.log('stretch_id: ', stretch_id)
                // console.log('operator_id: ', operator_id)
                // busco el servicio
                var resultStretch = collaboratorStretches.find(function (stretch) { return stretch.id === stretch_id && stretch.operator_id === operator_id; });
                // console.log('stretch encontrado: ', resultStretch)
                var schedules = resultStretch.horasIda;
                var _loop_3 = function (value) {
                    // console.log('collaboratorHoursSelectedKey: ', value)
                    // busco el schedule con el id de value
                    // @ts-ignore  // TODO (viene con formato number del servidor)
                    var tempHora = schedules.find(function (schedule) { return schedule.id === value; });
                    if (tempHora) {
                        if (!result[key]) {
                            result[key] = [tempHora];
                        }
                        else {
                            result[key].push(tempHora);
                        }
                    }
                };
                for (var _b = 0, entrieValue_1 = entrieValue; _b < entrieValue_1.length; _b++) {
                    var value = entrieValue_1[_b];
                    _loop_3(value);
                }
            };
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], key = _a[0], entrieValue = _a[1];
                _loop_2(key, entrieValue);
            }
            // console.log('mapCollaboratorHoursSelected - result: ', result)
            return result;
        };
        _this.handleChange = function (name, value, column) {
            var _a;
            // console.log('handleChange: ', `name: ${name} value: ${value} column: ${column}`)
            // console.log('handleChange: value: ', value)
            // console.log('handleChange: column: ', column)
            if (column === 'stretchValues' && value instanceof Array) {
                var stretchValues = value;
                var stretchesSelected_1 = [];
                value.forEach(function (id) {
                    var result = _this.props.store.stretches.data.find(function (stretch) { return stretch.id === Number(id); });
                    if (result) {
                        stretchesSelected_1.push(result);
                    }
                });
                _this.setState({ stretchesSelected: stretchesSelected_1, stretchValues: stretchValues });
            }
            else if (column === 'collaboratorStretchValues' && value instanceof Array) {
                var collaboratorStretchValues = value.map(function (item) { return JSON.parse(item); });
                var collaboratorStretchesSelected_1 = [];
                collaboratorStretchValues.forEach(function (item) {
                    // console.log('item: ', item)
                    var result = _this.props.store.collaboratorStretchesStore.datas
                        .find(function (collaboratorStretch) { return collaboratorStretch.id === Number(item.stretch_id) && collaboratorStretch.operator_id === item.operator_id; });
                    // console.log('result: ', result)
                    if (result) {
                        collaboratorStretchesSelected_1.push(result);
                    }
                });
                _this.setState({ collaboratorStretchesSelected: collaboratorStretchesSelected_1, collaboratorStretchValues: collaboratorStretchValues });
            }
            else {
                console.log('handleChange - else');
                // @ts-ignore
                _this.setState((_a = {}, _a[column ? column : name] = value, _a));
            }
        };
        _this.handleChangePrices = function (name, value) {
            var _a;
            // console.log('handleChangePrices: ', `name: ${name} value: ${value}`)
            _this.setState({ pricesValues: __assign(__assign({}, _this.state.pricesValues), (_a = {}, _a[name] = value, _a)) }, function () {
                // console.log('handleChangePrices: state.values', this.state.values)
            });
        };
        _this.handleHorasIdaSelected = function (horaIda, stretch, isInCollaborator) {
            if (!isInCollaborator) {
                var hoursSelected = _this.state.hoursSelected;
                var hoursSelectedFromStretch = hoursSelected[stretch.id] || [];
                var index = hoursSelectedFromStretch.findIndex(function (hour) { return hour.id === horaIda.id; });
                if (index >= 0) {
                    // elimino
                    hoursSelectedFromStretch.splice(index, 1);
                }
                else {
                    // la añado
                    hoursSelectedFromStretch.push(horaIda);
                }
                hoursSelected[stretch.id] = hoursSelectedFromStretch.length > 0 ? hoursSelectedFromStretch : null;
                _this.setState({ hoursSelected: hoursSelected });
            }
            else {
                var hoursSelectedCollaborator = _this.state.hoursSelectedCollaborator;
                var hoursSelectedFromStretch = hoursSelectedCollaborator[getIndexForMapeo(stretch)] || [];
                var index = hoursSelectedFromStretch.findIndex(function (hour) { return hour.id === horaIda.id; });
                console.log('hoursSelectedFromStretch: ', hoursSelectedFromStretch);
                if (index >= 0) {
                    // elimino
                    hoursSelectedFromStretch.splice(index, 1);
                }
                else {
                    // la añado
                    hoursSelectedFromStretch.push(horaIda);
                }
                hoursSelectedCollaborator[getIndexForMapeo(stretch)] = hoursSelectedFromStretch.length > 0 ? hoursSelectedFromStretch : null;
                _this.setState({ hoursSelectedCollaborator: hoursSelectedCollaborator });
            }
        };
        _this.handleIdaVuelta = function (vuelta, stretch, isInCollaborator) {
            if (!isInCollaborator) {
                var idaVueltaSelected = _this.state.idaVueltaSelected;
                idaVueltaSelected[stretch.id] = vuelta;
                _this.setState({ idaVueltaSelected: idaVueltaSelected });
            }
            else {
                var idaVueltaSelectedCollaborator = _this.state.idaVueltaSelectedCollaborator;
                // idaVueltaSelectedCollaborator[String(stretch.id)+(stretch as CollaboratorStretch).operator_id] = vuelta
                idaVueltaSelectedCollaborator[getIndexForMapeo(stretch)] = vuelta;
                _this.setState({ idaVueltaSelectedCollaborator: idaVueltaSelectedCollaborator });
            }
        };
        _this.handleCancel = function () {
            // console.log('handleCancel')
            var onCancel = _this.props.onCancel;
            if (onCancel)
                return onCancel();
            toParentPath();
        };
        _this.handleDisable = function (disable) { return function () {
            // console.log('handleDisable')
            var _a = _this.props, onDisable = _a.onDisable, packet = _a.packet;
            var accept = confirm(t(disable ? 'confirmDisable' : 'confirmEnable'));
            if (accept) {
                if (onDisable) {
                    return onDisable(disable);
                }
                if (packet) {
                    _this.props.store.packetStore.disable(packet.id, disable).then(toParentPath);
                }
            }
        }; };
        _this.handleDelete = function () {
        };
        _this.handleReset = function () {
        };
        _this.parsedPricesValues = function () {
            var values = _this.priceFields || [];
            var result = values.reduce(function (fields, field) {
                var _a;
                return __assign(__assign({}, fields), (_a = {}, _a[field.name] = field.value || field.value === 0 ? field.value :
                    (field.type === FieldType.Select
                        ? field.placeholder
                            ? null
                            : field.options && field.options[0] && field.options[0].value
                        : field.type === FieldType.Date ? new Date() : values[field.name]), _a));
            }, {});
            return result;
        };
        _this.handleSubmit = function () {
            var values = __assign({}, _this.state);
            // delete values.stretchValues
            delete values.pricesValues;
            // console.log('values: ', values)
            var pricesValues = _this.state.pricesValues;
            var validation = new Validation(values, _this.schema);
            var validationPacket = new Validation(values, _this.packetSchema);
            var errorMessage = '';
            // validamos reglas
            if (!validation.valid || !validationPacket.valid) {
                // alguna regla no se cumple
                if (!validation.valid) {
                    errorMessage += objectValues(validation.errors).join('\n');
                }
                if (!validationPacket) {
                    errorMessage += objectValues(validationPacket.errors).join('\n');
                }
                return _this.props.store.UI.newWarning(errorMessage);
            }
            // Eliminamos valores no modificados
            if (_this.props.packet) { // estamos editando
                var packet = _this.props.packet;
                for (var key in packet) {
                    if (packet.hasOwnProperty(key) && values.hasOwnProperty(key)) {
                        if (packet[key] === values[key]) {
                            delete values[key];
                        }
                    }
                }
                var propsPriceValues_1 = _this.parsedPricesValues();
                _this.priceFields.map(function (field) {
                    if (propsPriceValues_1 && pricesValues[field.name] === propsPriceValues_1[field.name]) {
                        delete pricesValues[field.name];
                    }
                });
            }
            if (Object.keys(values).length === 0 && Object.keys(pricesValues).length === 0)
                return mainStore.UI.newWarning(T('nothingModified'));
            // pasamos los strings vacíos a null
            for (var key in values) {
                if (values.hasOwnProperty(key)) {
                    if (values[key] === '') {
                        values[key] = null;
                    }
                }
            }
            pricesValues = mapValues(pricesValues, function (value) { return (value === '' ? null : value); });
            var data = {};
            if (pricesValues) {
                // paso a fortato válido para el backend
                data.pricesValues = _this.changeToId(pricesValues);
            }
            data.values = values;
            // eliminamos stretchesSelected
            delete data.values.stretchesSelected;
            // console.log('enviando data: ', data)
            // console.log('enviando data.values.hoursSelected: ', data.values.hoursSelected)
            // eliminamos collaboratorStretchesSelected
            delete data.values.collaboratorStretchesSelected;
            // desmapeamos hourSelected
            var unmapHoursSelected = {};
            for (var stretch_id in data.values.hoursSelected) {
                if (data.values.hoursSelected.hasOwnProperty(stretch_id)) {
                    var hours = data.values.hoursSelected[stretch_id];
                    if (hours) {
                        unmapHoursSelected[stretch_id] = hours.map(function (hour) { return hour.id; });
                    }
                    else {
                        return _this.props.store.UI.newWarning(T('notHourSelected'));
                    }
                }
            }
            data.values.hoursSelected = unmapHoursSelected;
            // console.log('data.values.hoursSelected: ', data.values.hoursSelected)
            // desmapeamos hourSelectedCollaborator
            var unmapHoursSelectedCollaborator = {};
            for (var index in data.values.hoursSelectedCollaborator) {
                if (data.values.hoursSelectedCollaborator.hasOwnProperty(index)) {
                    var hours = data.values.hoursSelectedCollaborator[index];
                    if (hours) {
                        unmapHoursSelectedCollaborator[index] = hours.map(function (hour) { return hour.id; });
                    }
                    else {
                        return _this.props.store.UI.newWarning(T('notHourSelected'));
                    }
                }
            }
            data.values.hoursSelectedCollaborator = unmapHoursSelectedCollaborator;
            // ida o ida-vuelta
            data.values.idaVueltaSelected = _this.state.idaVueltaSelected;
            data.values.idaVueltaSelectedCollaborator = _this.state.idaVueltaSelectedCollaborator;
            data.values.stretchValues = data.values.stretchValues.map(function (stretchValue) { return Number(stretchValue); });
            // console.log('handleOnSubmit - data: ', data)
            if (_this.props.onSubmit) {
                _this.props.onSubmit(data);
            }
            var request;
            if (_this.props.packet) {
                request = _this.props.store.packetStore.update(_this.props.packet.id, data);
            }
            else {
                request = _this.props.store.packetStore.create(data);
            }
            request
                .then(function (value) {
                if (value) {
                    toParentPath();
                }
            })
                .catch(function (e) {
                console.log('error: ', e);
            });
        };
        _this.changeToId = function (stretchPrices) {
            // console.log('changeToId')
            var result = {};
            var pricesValues = _this.state.pricesValues;
            for (var item in stretchPrices) {
                if (stretchPrices.hasOwnProperty(item)) {
                    // console.log('changeToId - item', item)
                    result[_this.mapNameId[item]] = pricesValues[item];
                }
            }
            return result;
        };
        var packet = _this.props.packet || new Packet();
        // console.log('packet: ', packet)
        _this.state = {
            name: packet.name,
            code: packet.code,
            tax_id: packet.tax_id,
            operationLine_id: packet.operationLine_id,
            printPrice: packet.printPrice,
            headboard_id: packet.headboard_id,
            description: packet.description,
            emails: packet.emails,
            icon: packet.icon,
            stretchValues: packet.stretches.map(function (stretch) { return stretch.id; }),
            collaboratorStretchValues: packet.collaboratorStretches ? packet.collaboratorStretchValues : [],
            hoursSelected: _this.mapHoursSelected(packet.hoursSelected, _this.props.schedules),
            hoursSelectedCollaborator: _this.mapCollaboratorHoursSelected(packet.hoursSelectedCollaborator, packet.collaboratorStretches || []),
            idaVueltaSelected: packet.idaVueltaSelected || {},
            idaVueltaSelectedCollaborator: packet.idaVueltaSelectedCollaborator || {},
            article_id: packet.article_id,
            quantityArticle: packet.quantityArticle,
            pricesValues: _this.priceFields.reduce(function (prev, current) {
                var _a;
                return __assign(__assign({}, prev), (_a = {}, _a[current.name] = current.value, _a));
            }, {}),
            stretchesSelected: packet.stretches,
            collaboratorStretchesSelected: packet.collaboratorStretches || [],
            aditional: packet.aditional
        };
        _this.priceFields.forEach(function (priceField) {
            _this.mapNameId[priceField.name] = priceField.id;
        });
        return _this;
    }
    PacketsF.prototype.render = function () {
        var _this = this;
        var isLoading = ['post@packets/', 'put@packets/', 'delete@packets/'];
        var hasParent = (History.location.pathname.match(/\//g) || []).length >= 2;
        var canBeDeleted = false;
        var canBeDisabled = 'disabled_at' in (this.props.packet || {});
        var disabled = canBeDisabled && this.props.packet.disabled_at != null;
        var _a = this.state, name = _a.name, code = _a.code, tax_id = _a.tax_id, operationLine_id = _a.operationLine_id, printPrice = _a.printPrice, headboard_id = _a.headboard_id, description = _a.description, emails = _a.emails, icon = _a.icon, stretchValues = _a.stretchValues, collaboratorStretchValues = _a.collaboratorStretchValues, article_id = _a.article_id, quantityArticle = _a.quantityArticle, pricesValues = _a.pricesValues, stretchesSelected = _a.stretchesSelected, collaboratorStretchesSelected = _a.collaboratorStretchesSelected, aditional = _a.aditional;
        var taxValue = this.props.store.taxes.findById(tax_id);
        return (React.createElement(Wrapper, null,
            React.createElement(Field, { field: {
                    name: 'name',
                    value: name,
                    type: FieldType.Text,
                    size: 6,
                    rules: this.schema['name']
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'code',
                    value: code,
                    type: FieldType.Text,
                    size: 4,
                    rules: this.schema['code']
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'tax',
                    value: tax_id,
                    column: 'tax_id',
                    type: FieldType.Select,
                    rules: this.schema['tax'],
                    options: this.taxesOptions,
                    size: 2,
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'operationline',
                    value: operationLine_id,
                    column: 'operationLine_id',
                    type: FieldType.Select,
                    rules: this.schema['operationline'],
                    options: this.operationsOptions,
                    size: 2
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'printPrice',
                    value: printPrice !== undefined ? printPrice : true,
                    type: FieldType.Checkbox,
                    rules: this.schema['printPrice'],
                    size: 2,
                    defaultValue: true,
                    tooltip: 'Imprime precio en el ticket'
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'headboard',
                    value: headboard_id,
                    column: 'headboard_id',
                    type: FieldType.Select,
                    rules: this.schema['headboard'],
                    size: 2,
                    options: this.headboardsOptions,
                    defaultValue: this.headboardsOptions && this.headboardsOptions.length > 0 ? this.headboardsOptions[0] : null
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'description',
                    value: description,
                    type: FieldType.TextArea,
                    rules: this.schema['description'],
                    size: 10,
                    tooltip: 'Descripción del paquete'
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'emails',
                    value: emails,
                    type: FieldType.Text,
                    rules: this.schema['emails'],
                    size: 10,
                    tooltip: 'Emails del servicio'
                }, onChange: this.handleChange }),
            React.createElement(Field, { field: {
                    name: 'icon',
                    value: icon,
                    type: FieldType.Icon,
                    size: 12,
                    icons: Iconos,
                    rules: this.schema['icon']
                }, onChange: this.handleChange }),
            React.createElement("div", { style: { display: 'flex', flexDirection: 'row', flex: '1 1 100%', border: "1px solid ".concat(Theme.color.hairline) } },
                React.createElement("div", { style: { flex: '1 1 40%', margin: 20, border: "1px solid ".concat(Theme.color.hairline), padding: 20 } },
                    React.createElement(Field, { field: {
                            name: 'stretchValues',
                            value: stretchValues,
                            column: 'stretchValues',
                            type: FieldType.MultiSelect,
                            options: this.stretchesOptions,
                            rules: this.props.packet ? undefined : rules().required(),
                            size: 10,
                            tooltip: 'Servicios que se incluyen en el bono'
                        }, onChange: this.handleChange }),
                    React.createElement(Field, { field: {
                            name: 'collaboratorStretchValues',
                            value: collaboratorStretchValues,
                            column: 'collaboratorStretchValues',
                            type: FieldType.MultiSelect,
                            options: this.collaboratorStretchesOptions,
                            rules: this.props.packet ? undefined : rules().required(),
                            size: 10,
                            tooltip: 'Servicios en colaboaración que se incluyen en el bono'
                        }, onChange: this.handleChange })),
                React.createElement("div", { style: { flex: '1 1 100%', margin: 20, border: "1px solid ".concat(Theme.color.hairline), padding: 20 } }, (stretchesSelected.length > 0 || collaboratorStretchesSelected.length > 0) &&
                    React.createElement("div", { style: { display: 'block' } },
                        stretchesSelected.length > 0 &&
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { style: { height: '10px', backgroundColor: Theme.color.hairline, width: '100%' } }),
                                React.createElement(Text, { style: { marginTop: 10, marginBottom: 10 } }, 'Configuración de los servicios incluidos en paquete'),
                                React.createElement("div", { style: { height: '10px', backgroundColor: Theme.color.hairline, width: '100%' } }),
                                React.createElement(SettingService, { selected: stretchesSelected, handleHorasIdaSelected: this.handleHorasIdaSelected, handleIdaVuelta: this.handleIdaVuelta, hoursSelected: this.state.hoursSelected, idaVueltaSelected: this.state.idaVueltaSelected }),
                                React.createElement("div", { style: { marginTop: Theme.common.size.space * 2 } })),
                        collaboratorStretchesSelected.length > 0 &&
                            React.createElement(React.Fragment, null,
                                React.createElement("div", { style: { height: '10px', backgroundColor: Theme.color.hairline, width: '100%' } }),
                                React.createElement(Text, { style: { marginTop: 10, marginBottom: 10 } }, 'Configuración de los servicios en colaboración icluidos en paquete'),
                                React.createElement("div", { style: { height: '10px', backgroundColor: Theme.color.hairline, width: '100%' } }),
                                React.createElement(SettingService, { selected: collaboratorStretchesSelected, handleHorasIdaSelected: function (horaIda, stretch) { _this.handleHorasIdaSelected(horaIda, stretch, true); }, handleIdaVuelta: function (vuelta, stretch) { return _this.handleIdaVuelta(vuelta, stretch, true); }, hoursSelected: this.state.hoursSelectedCollaborator, idaVueltaSelected: this.state.idaVueltaSelectedCollaborator }))))),
            React.createElement(Field, { field: {
                    name: 'aditional',
                    value: aditional,
                    type: FieldType.TextArea,
                    rules: rules()
                        .string()
                        .max(10),
                    size: 10,
                    tooltipId: 'aditional',
                    tooltip: Traduce('aditionalPacket')
                }, onChange: this.handleChange }),
            React.createElement(Calculator, { taxValue: taxValue, styles: { flex: '1 1 100%' } }),
            React.createElement("div", { style: {
                    display: 'block',
                    marginLeft: '20px',
                    marginTop: '10px'
                } },
                React.createElement("label", { style: {
                        fontSize: 'large',
                        paddingTop: '30px',
                        marginLeft: '20px'
                    } }, T('pricesWithoutTax')),
                this.priceFields.length > 0 && React.createElement(WrapperPrices, null, this.priceFields.map(function (field) {
                    // console.log('field', field)
                    return (React.createElement(Field, { key: field.name, field: __assign(__assign({}, field), { value: pricesValues[field.name] || (pricesValues[field.name] === 0 ? '0' : '') }), onChange: _this.handleChangePrices }));
                })),
                this.priceFields.length === 0 && (React.createElement("div", null, "No hay categor\u00EDas de pasajero, por favor a\u00F1ada categor\u00EDas de pasajero"))),
            React.createElement(ButtonsBar, null,
                hasParent && (React.createElement(StyledButton, { onClick: this.handleCancel }, t('cancel'))),
                this.props.packet && canBeDisabled ? (disabled ? (React.createElement(StyledButton, { isDisabled: true, onClick: this.handleDisable(false) }, t('enable'))) : (React.createElement(StyledButton, { onClick: this.handleDisable(true) }, t('disable')))) : canBeDeleted ? (React.createElement(StyledButton, { onClick: this.handleDelete }, t('delete'))) : null,
                React.createElement(StyledButton, { primary: true, loading: isLoading, onClick: this.handleSubmit }, t('save')))));
    };
    PacketsF = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.store.passengerCategories.read().then(function (passengerCategories) {
                // console.log('finalizado passengerCategories read')
                return { passengerCategories: passengerCategories };
            }),
            props.match.params.id
                ? props.store.packetStore
                    .read(props.match.params.id)
                    .then(function (packet) {
                    // console.log('loading - read - packet: ', packet)
                    return { packet: packet };
                })
                : undefined,
            props.store.operationLines.read().then(function (operationLines) { return ({ operationLines: operationLines }); }),
            props.store.headboardStore.read().then(function (headboards) { return ({ headboards: headboards }); }),
            props.store.stretches.read().then(function (stretches) { return ({ stretches: stretches }); }),
            props.store.taxes.read().then(function (taxes) { return ({ taxes: taxes }); }),
            props.store.articles.read().then(function (articles) { return ({ articles: articles }); }),
            props.store.scheduleStore.read().then(function (schedules) { return ({ schedules: schedules }); }),
            props.store.collaboratorStretchesStore.read().then(function (collaboratorStretches) { return ({ collaboratorStretches: collaboratorStretches }); })
        ]; }),
        observer
    ], PacketsF);
    return PacketsF;
}(Component));
export default PacketsF;
var Wrapper = cxs('div')((_a = {
        paddingBottom: Theme.size.bar
    },
    _a[mediaQueries.desktop] = {
        marginBottom: Theme.size.bottomButtons,
        display: 'flex',
        flexWrap: 'wrap',
    },
    _a));
var WrapperPrices = cxs('div')((_b = {
        paddingLeft: '20px'
    },
    _b[mediaQueries.desktop] = {
        display: 'flex',
        flexWrap: 'wrap',
        paddingBottom: 0
    },
    _b));
var StyledButton = cxs(Button)(function (_a) {
    var _b;
    var isDisabled = _a.isDisabled;
    return (_b = {
            flex: 2,
            color: isDisabled ? Theme.color.primary : 'inherit'
        },
        _b[mediaQueries.desktop] = {
            padding: Theme.size.space[2]
        },
        _b);
});
var buttonStyle = function (enabled) {
    return {
        backgroundColor: enabled ? 'green' : 'whitesmoke',
        border: '1 solid red',
        borderStyle: 'solid',
        borderColor: 'red',
        borderWidth: '1px',
        borderRadius: 5
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/Packets/container/PacketsF.tsx
// module id = 1542
// module chunks = 0